import React, { useState, useEffect } from 'react';
import ApiService from '../services/ApiService';
import '../App.css';
import './admin/AdminPage.css';
import AdminLayout from './admin/AdminLayout';

const CategoryManagementPage = () => {
    const [categories, setCategories] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [categoryAvailable, setCategoryAvailable] = useState(true);
    const [categoryPriority, setCategoryPriority] = useState(1);
    const [categoryAnimeIds, setCategoryAnimeIds] = useState([]);
    const [selectedId, setSelectedId] = useState(-1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const categoriesData = await ApiService.getCategories();
            setCategories(categoriesData.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching categories:', error.message);
        }
    };


    const handleEditCategory = async () => {
        try {
            const category = {
                id: selectedId,
                name: categoryName,
                available: categoryAvailable,
                priority: categoryPriority,
                animeIds: categoryAnimeIds
            };
            await ApiService.setCategory(category);
            // Clear the input fields and fetch updated categories

        } catch (error) {
            console.error('Error adding category:', error.message);
        }
    };
    const handleAddEmptyCategory = async () => {
        try {
            const category = {
                name: categoryName,
                available: categoryAvailable,
                priority: categoryPriority,
                animeIds: categoryAnimeIds
            };
            await ApiService.setCategory(category);
            // Clear the input fields and fetch updated categories

        } catch (error) {
            console.error('Error adding category:', error.message);
        }
    };

    const handleLoadCategory = (category) => {
        // Handle edit functionality here
        setSelectedId(category.id);
        setCategoryName(category.name);
        setCategoryAvailable(category.available);
        setCategoryPriority(category.priority);
        setCategoryAnimeIds(category.animeIds);

    };

    if (loading) {
        return (
            <AdminLayout>
                <p className="ui-status">Загружаем…</p>
            </AdminLayout>
        );
    }

    return (
        <AdminLayout eyebrow="Контент" title="Категории">
            <section className="ui-panel admin-simple-card">
                <h2>{selectedId ? `Категория ${selectedId}` : 'Новая категория'}</h2>
                <label className="admin-field">
                    <span>Название</span>
                    <input
                        type="text"
                        placeholder="Название категории"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                    />
                </label>
                <div className="admin-simple-row">
                    <input
                        type="checkbox"
                        id="editSeries"
                        name="editSeries"
                        checked={categoryAvailable}
                        onChange={(e) => setCategoryAvailable(e.target.checked)}
                    />
                    <label className='label-switch' htmlFor='editSeries'>Доступна</label>
                </div>
                <label className="admin-field">
                    <span>Приоритет</span>
                    <input
                        type="number"
                        value={categoryPriority}
                        onChange={(e) => setCategoryPriority(parseInt(e.target.value))}
                    />
                </label>
                <label className="admin-field">
                    <span>ID аниме через запятую</span>
                    <input
                        type="text"
                        value={categoryAnimeIds.join(',')}
                        onChange={(e) => setCategoryAnimeIds(e.target.value.split(','))}
                    />
                </label>
                <div className="admin-simple-row">
                    <button type="button" className="ui-btn ui-btn--sm" onClick={handleEditCategory}>Сохранить</button>
                    <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" onClick={handleAddEmptyCategory}>Создать пустую</button>
                </div>
            </section>
            <section className="ui-panel admin-simple-card">
                <h2>Все категории</h2>
                <p className="ui-status admin-simple-note">Список обновляется после перезагрузки страницы.</p>
                <ul>
                    {categories.map((category) => (
                        <li key={category.id}>
                            <p>
                                {category.name} ({category.id}) — {category.available ? 'Доступна' : 'Недоступна'} · Приоритет: {category.priority} · Аниме: {category.animeIds.join(',')}
                            </p>
                            <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" onClick={() => handleLoadCategory(category)}>Изменить</button>
                        </li>
                    ))}
                </ul>
            </section>
        </AdminLayout>
    );
};

export default CategoryManagementPage;
